<div class="tabs">
  <ng-container *ngFor="let tab of tabs">
    <button class="q-btn tab-button" [ngClass]="{'tab-select': tab.Active}" (click)="ActiveTab(tab.Type)">{{tab.Name}}</button>
  </ng-container>
</div>

<div *ngIf="isLoading" class="justify-content-center row w-100 my-5"><i class="fas fa-spin fa-spinner fa-pulse q-c-main fa-5x"></i></div>
<div class="row w-100 mx-0 blockReserv" [ngClass]="{'d-none': isLoading}">
  <div class="col-lg-3">
    <q-planning-calendrier class="row"></q-planning-calendrier>
    <q-planning-creation class="row" [ngClass]="{'d-none': !tabs[0].Active }"></q-planning-creation>
  </div>
  <div class="col-lg-9 pl-lg-5">
    <ng-container *ngIf="planningService.View == PlanningOnglet.ReservBureau else defaultView">
      <q-reservations-bureau></q-reservations-bureau>
    </ng-container>
    <ng-template #defaultView>
      <fieldset class="q-fieldset my-1">
        <legend><i class="fas fa-filter"></i>Filtres</legend>
        <div *ngIf="planningService.Filter">
          <div class="row">
            <div class="col-lg-6">
              <div class="row align-items-center ml-1">
                Filtrer : Du <q-date class="mr-3" style="width: 150px;" [(ngValue)]="planningService.Filter.DateDebut" (blur)="planningService.OnRefreshDisplay()"></q-date> au <q-date class="ml-2" style=" width: 150px;" [(ngValue)]="planningService.Filter.DateFin" (blur)="planningService.OnRefreshDisplay()"></q-date>
              </div>
            </div>
            <div class="col-lg-2" *ngIf="(planningService?.View == PlanningOnglet.Planning || planningService?.View == PlanningOnglet.SuiviPresence)">
              <div class="q-check" *ngIf="!isCustomGrid">
                <input type="checkbox" id="checkAll" [checked]="planningService.isSelectAll || planningService.Filter.IndeterminateSelect" [indeterminate]="planningService.Filter.IndeterminateSelect" (change)="ChangeSelect()" />
                <label for="checkAll">
                  <span></span>
                  Tout sélectionner
                </label>
              </div>
            </div>
            <div class="col-lg-2">
              <div *ngIf="planningService.ListeFormateurs && planningService.ListeFormateurs.length > 0 " class="row ml-1 align-items-center">
                <strong class="mr-1">Formateur :</strong>

                <q-avatar-search [elementList]="planningService.ListeFormateurs"
                                 labelPropName="Value"
                                 identPropName="Id"
                                 imgPropName="ProfilePicture"
                                 [value]="planningService.Filter.Formateurs | PersonToListId"
                                 (selectedList)="SetFilterFormateur($event)"
                                 [multipleSelection]="true" class="d-inline-block">
                </q-avatar-search>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="display-mode float-right switchCGrid">
                <i class="fas fa-columns q-c-main m-1"></i>
                <div class="checkbox checbox-switch switch-primary d-inline">
                  <label>
                    <input type="checkbox" [(ngModel)]="isCustomGrid">
                    <span></span>
                  </label>
                </div>
                <i class="fas fa-list-alt q-c-main"></i>
              </div>
            </div>
          </div>
        
          <div class="row justify-content-center" *ngIf="HasNewReserv()" [ngClass]="{'d-none' : planningService.View == PlanningOnglet.SuiviPresence}">
            <label class="mr-1">Afficher uniquement les réservations en cours de création :</label>
            <div class="checkbox checbox-switch switch-primary d-inline text-left">
              <label>
                <input type="checkbox" (click)="planningService.ShowOnlyNewReserv()" />
                <span></span>
              </label>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset *ngIf="isApiSoWeSignExist" class="q-fieldset my-1">
        <legend>          
          <a href="{{soWeSignURLportail.StrValue}}" target="_blank" style="color:white" title="Accéder au portail SoWeSign">
            <i class="fas fa-signature mr-2"></i>
            SOWESIGN
            <i class="fas fa-sign-in-alt ml-2"></i>
          </a>
        </legend>
        <div class="row">
          <div class="col-lg-10">
            <button class="q-btn q-main" (click)="SetReferentielSoWeSign();" [disabled]="isLoading" title="Envoyer le référentiel des apprenants, formateurs, stage et réservations dans SoWeSign">Envoyer les réservations</button>
            <button *ngIf="!isCustomGrid" class="q-btn q-main ml-2" (click)="SendSignatureSoWeSign();" [disabled]="isLoading" title="Créer une demande de signatures en envoyant un mail expirant au bout de 24 heures pendant la période de signature ou durant la séance par SoWeSign, sinon créer une demande de rattrapage en envoyant un mail avec une durée limite">Demander les signatures</button>
            <button *ngIf="!isCustomGrid" class="q-btn q-main ml-2" (click)="GetSignatureSoWeSign();" [disabled]="isLoading" title="Récupérer les présences et les signatures de SoWeSign">Récupérer les signatures</button>
          </div>
        </div>

      </fieldset>

        <q-liste-reservations [displayMode]="isCustomGrid" [selectAll]="planningService.isSelectAll"></q-liste-reservations>
    </ng-template>
  </div>

</div>
